import { formatedPhoneNumber, unformatedPhoneNumber } from './phoneFormatter';

export default {
  displayFormat(value) {
    const numberLength = 9;
    const mask = '__ ___-__-__';
    return formatedPhoneNumber(value, mask, numberLength);
  },

  modelFormat(valueToFormat) {
    const value = unformatedPhoneNumber(valueToFormat);
    return value;
  },
};
